<template>
  <ModalDialog :show="showModal" @close="closeModal()" targetClass="fullvh" :backgroundColor="'#5D50C6'">
    <div class="loop-modal">
      <div class="promo-modal-header">
        <h3 class="promo-modal-title">{{ $t("promoModal.blackFriday2025.title") }}</h3>
        <div class="promo-dates">
          {{ $t("promoModal.blackFriday2025.dates") }}
        </div>
      </div>
      <div class ="promo-modal-image">
        <img v-show="$i18n.locale == 'es-ES'" src="../assets/img/covers/monitorizacion-precios-baby-ES.png" alt="HelloWish Premium Gift">
        <img v-show="$i18n.locale == 'fr-FR'" src="../assets/img/covers/monitorizacion-precios-baby-FR.png" alt="HelloWish Premium Gift">
        <img v-show="$i18n.locale == 'it-IT'" src="../assets/img/covers/monitorizacion-precios-baby-IT.png" alt="HelloWIsh Premium Gift">
        <img v-show="$i18n.locale !== 'es-ES' && $i18n.locale !== 'fr-FR' && $i18n.locale !== 'it-IT'" src="../assets/img/covers/monitorizacion-precios-baby-EN.png" alt="HelloWish Premium Gift">
      </div>
      <div class="promo-description">
        {{ $t("promoModal.blackFriday2025.description") }}
      </div>
      <div class="promo-modal-buttons">
        <button class="button button--primary" @click="subscribe()">{{ $t("promoModal.blackFriday2025.ctaOk") }}</button>
        <button class="button button--secondary" @click="unsubscribe()">{{ $t("promoModal.blackFriday2025.ctaCancel") }}</button>
      </div>
    </div>
  </ModalDialog>
</template>

<script>
import { mapGetters } from "vuex";
import ModalDialog from "./ui/ModalDialog.vue";

export default {
  name: "LoopModal",
  components: { ModalDialog },
  props: {
    backgroundColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showModal: false,
      notShowDate: null
    };
  },
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    closeModal() {
      //close modal and not show it never again - save a flag in localstorage
      this.showModal = false;
      localStorage.setItem("promoModalHidden", "true");
      window.mixpanel.track("promo modal closed", {
        promo: "black_friday_2025"
      });
    },
    subscribe() {
      localStorage.setItem("promoModalHidden", "true");
      //push to subscribe page
      this.$router.push({ path: "/subscribe", query: { group: "black_friday_2025" } });
    },
    unsubscribe() {
      localStorage.setItem("promoModalHidden", "true");
      //push to unsubscribe page
      this.$router.push({ path: "/unsubscribe", query: { group: "black_friday_2025" } });
    },
    encryptSubscription() {
      
    }
  },
  mounted() {
    //if textColor are set, apply them to the document root (promo-modal-title, promo-dates and promo-description)
    if (this.textColor) {
      const style = document.createElement("style");
      style.type = "text/css";
      style.innerHTML = `
        .promo-modal-title, .promo-dates, .promo-description {
          color: ${this.textColor} !important;
        }
      `;
      document.head.appendChild(style);
    }
    if(localStorage.getItem("promoModalHidden") === "true") {
      this.showModal = false;
    } else {
      // show modal after 1 second
      setTimeout(() => {
        this.showModal = true;
      }, 1000);
      window.mixpanel.track("promo modal shown", {
        promo: "black_friday_2025"
      });
    }
  },
};
</script>

<style scoped>
.loop-modal {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.promo-modal-title {
    font-weight: 600;
    font-size: 2rem;
    flex: 0 0 auto;
}

.promo-modal-header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
}
.promo-dates {
  font-size: 1.5rem;
  font-weight: 500;
}

.loop-modal-content {
  font-size: 1.12rem;
}

.loop-modal-content-points {
  text-align: left;
  margin: 0 auto;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
}

.loop-modal-content-points span {
  margin-bottom: 0;
}

.loop-modal button {
  max-width: 200px;
  margin: 0 auto;
  flex: 0 0 auto;
}

.promo-modal-image {
  width: 300px;
  height: auto;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.promo-modal-image img {
  max-width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
}
.loop-modal button {
  width: 100%;
}

.promo-modal-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-direction: row;
}

@media screen and (max-width: 768px) {
  .loop-modal {
    padding: 0rem 0.12rem 0rem 0rem;
    gap: 1rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 95vh;
  }
  .promo-modal-header {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
  }
  .promo-modal-title {
    font-size: 2.12rem;
    font-weight: 700;
    line-height: 1.1;
    text-align: left;
  }
  .promo-dates {
    font-size: 1.25rem;
    text-align: left;
    font-weight: 700;
  }
  .loop-modal-title {
    font-size: 2rem;
    line-height: 1.4;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  .loop-modal button {
    width: 100%;
  }
  .promo-modal-image {
    width: 100%;
    max-height: clamp(20vh, 50vh, 60vh);
    overflow: hidden;
  }
  .promo-modal-image img {
    max-height: 100%;
  }
  .loop-modal-content-points {
    margin: 0 1rem;
  }
  .promo-modal-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    /* bring buttons to the bottom */
    margin-top: auto;
  }
  .loop-modal button {
    max-width: 100%;
  }
  .promo-description {
    font-size: 0.9rem;
  }
}
</style>
